import { injectable } from 'inversify';
import LanguageModel from '../common/model/LanguageModel';
import { IOnboardingLookupService } from './interfaces';
import DIContainer from '../config/di.container';
import DITYPES from '../config/di.types';
import APIService from './ApiService';
import OnBoardingRequestModel from '../common/model/OnBoardingRequestModel';
import LocalStorageService from './local.storage.service';
import {
    onBoardingIntegrationTypeLocalStorageKey, onBoardingLanguageLocalStorageKey,
    onBoardingCountryLocalStorageKey, onBoardingLookpResultLocalStorageKey,
    onBoardingBusinessNameLocalStorageKey,
    userDetailsLocalStorageKey
} from '../common/constant';
import IntegrationTypeModel from '../common/model/IntegrationtypeModel';
import GoLiveCreateRequest from '../common/model/GoLiveCreateRequest';
import ApiService from './ApiService';
import { OnBoardingLookupResultModel } from '../common/model/OnBoardingLoopResultModel';
import CreateAccountRequest from '../common/model/CreateAccountRequest';
import GenericDropDownModel from '../common/model/GenericDropDownModel';
import { CountryModel } from '../common/model/CountryModel';
import UserDetails from '../common/model/UserDetails';
import { EComponentName } from '../common/enum/EComponentName';

@injectable()
class OnBoardingLookupService implements IOnboardingLookupService {
    developerPortalBaseUrl = process.env.REACT_APP_BASE_URL;
    localStorageService: LocalStorageService;
    apiService: APIService;

    constructor() {
        this.localStorageService = DIContainer.get<LocalStorageService>(DITYPES.LocalstorageService);
        this.apiService = DIContainer.get<ApiService>(DITYPES.ApiService);
    }

    getLanguages = async (): Promise<LanguageModel[]> => {
        let localStoageLanguage = this.localStorageService.get(onBoardingLanguageLocalStorageKey);
        let languages: LanguageModel[];
        if (localStoageLanguage && JSON.parse(localStoageLanguage) as LanguageModel[]) {
            languages = JSON.parse(localStoageLanguage) as LanguageModel[];
        }
        else {

            var onBoardingRequest = new OnBoardingRequestModel();
            onBoardingRequest.IsLanguage = true;          
            var response = await this.apiService.post(`${this.developerPortalBaseUrl}onboarding/create-account-lookup`, onBoardingRequest);
            response = await response.data.Languages;
            this.localStorageService.set(onBoardingLanguageLocalStorageKey, JSON.stringify(response))
            languages = response as LanguageModel[];
        }
        return languages;
    }

    getItegrationTypes = async (): Promise<IntegrationTypeModel[]> => {
        let localStoageIntegration = this.localStorageService.get(onBoardingIntegrationTypeLocalStorageKey);
        let integrationTypeModel: IntegrationTypeModel[];
        if (localStoageIntegration && JSON.parse(localStoageIntegration) as IntegrationTypeModel[]) {
            integrationTypeModel = JSON.parse(localStoageIntegration) as IntegrationTypeModel[];
        }
        else {
            var onBoardingRequest = new OnBoardingRequestModel();
            onBoardingRequest.IsIntegrationType = true;           
            var response = await this.apiService.post(`${this.developerPortalBaseUrl}onboarding/create-account-lookup`, onBoardingRequest);
            response = await response.data.IntegrationTypes;
            this.localStorageService.set(onBoardingIntegrationTypeLocalStorageKey, JSON.stringify(response))
            integrationTypeModel = response as IntegrationTypeModel[];
        }
        return integrationTypeModel;
    }

    createGoLiveRequest = async (request: GoLiveCreateRequest): Promise<any> => {
        try {
            var response = await this.apiService.post(`${this.developerPortalBaseUrl}onboarding/request-go-live`, request);

            return response;
        }
        catch (error) {
            console.log("createGoLiveRequest ERROR", error)
        }
    }
    getCreateAccountLookup = async (OnBoardingRequestModel: OnBoardingRequestModel): Promise<OnBoardingLookupResultModel> => {
        try {
            let localLookupResult = this.localStorageService.get(onBoardingLookpResultLocalStorageKey);
            if (localLookupResult && JSON.parse(localLookupResult) as OnBoardingLookupResultModel) {
                return JSON.parse(localLookupResult) as OnBoardingLookupResultModel;
            }

            var response = await this.apiService.post(`${this.developerPortalBaseUrl}onboarding/create-account-lookup`, OnBoardingRequestModel);

            response = await response.data;
            this.localStorageService.set(onBoardingLookpResultLocalStorageKey, JSON.stringify(response))

            return response as OnBoardingLookupResultModel;
        }
        catch (error) {
            console.log("getCreateAccountLookup ERROR", error)
            throw error;
        }
    }

    createAccountRequest = async (createAccountRequest: CreateAccountRequest): Promise<any> => {
        try {
            var response = await this.apiService.post(`${this.developerPortalBaseUrl}onboarding/create-account`, createAccountRequest);

            if (response?.data?.error == null) {
                var userDetails = new UserDetails();
                userDetails.FirstName = createAccountRequest.FirstName;
                userDetails.LastName = createAccountRequest.LastName;
                userDetails.BusinessName = createAccountRequest.BusinessName;
                userDetails.Website = createAccountRequest.WebSite;

                this.localStorageService.set(onBoardingBusinessNameLocalStorageKey, JSON.stringify(createAccountRequest.BusinessName));
                this.localStorageService.set(userDetailsLocalStorageKey, JSON.stringify(userDetails));

                return response;
            }
            else {
                return null;
            }
        }
        catch (error) {
            console.log("createAccountRequst ERROR", error)
        }
    }

    getCountries = async (): Promise<any> => {
        try {
            let localStorageCountry = this.localStorageService.get(onBoardingCountryLocalStorageKey);

            if (localStorageCountry && JSON.parse(localStorageCountry) as CountryModel[]) {
                return JSON.parse(localStorageCountry) as CountryModel[];
            }
            var onBoardingRequest = new OnBoardingRequestModel();
            onBoardingRequest.IsCountry = true;

            var response = await this.apiService.post(`${this.developerPortalBaseUrl}onboarding/create-account-lookup`, onBoardingRequest);
            if (response) {
                response = response.data.Countries;
                this.localStorageService.set(onBoardingCountryLocalStorageKey, JSON.stringify(response))
                return response as CountryModel[];
            }
        }
        catch (error) {
            console.log("getCountries ERROR", error)
        }
    }

    getStates = async (countryCode: string): Promise<any> => {
        try {
            var stateObj: any = {};
            stateObj.CountryCode = countryCode;
            let localStorageStates = this.localStorageService.get("onBoardingStatesLocalStorageKey");
            if (localStorageStates && JSON.parse(localStorageStates).CountryCode == countryCode) {
                stateObj.States = JSON.parse(localStorageStates).States as GenericDropDownModel[];
                return stateObj;
            }

            var onBoardingRequest = new OnBoardingRequestModel();
            onBoardingRequest.IsStates = true;
            onBoardingRequest.CountryCode = countryCode;

            var response = await this.apiService.post(`${this.developerPortalBaseUrl}onboarding/create-account-lookup`, onBoardingRequest);
            if (response) {
                stateObj.States = await response.data.States;
                this.localStorageService.set("onBoardingStatesLocalStorageKey", JSON.stringify(stateObj))
                return stateObj;
            }

        }
        catch (error) {
            console.log("getStates ERROR", error);
        }
    }

    getExpiryYears = async (): Promise<GenericDropDownModel[]> => {
        let localStoageExpiryYears = this.localStorageService.get("onBoardingExpiryYearsLocalStorageKey");
        if (localStoageExpiryYears && JSON.parse(localStoageExpiryYears) as GenericDropDownModel[]) {
            return JSON.parse(localStoageExpiryYears) as GenericDropDownModel[];
        }
        var todaysYear = new Date().getFullYear();

        var years: GenericDropDownModel[] = [];
        for (var i = 0; i < 10; i++) {
            years.push({
                Value: todaysYear.toString(),
                Label: todaysYear.toString()
            });
            todaysYear++;
        }

        this.localStorageService.set("onBoardingExpiryYearsLocalStorageKey", JSON.stringify(years))
        return years;
    }

    activateAndLaunchRequest = async (data: any): Promise<any> => {
        try {
            var response = await this.apiService.post(`${this.developerPortalBaseUrl}onboarding/activate-launch`, data);
            
            if(response)
            {
                return response;  
            }
                     
        }
        catch (error) {
            console.log("Activate And Launch ERROR", error)
        }
    }
}

export default OnBoardingLookupService